import {Component, Input, OnInit} from '@angular/core';
import {Conclusion} from '@namespaces/conclusion.namespace';
import InspectionWithForm = Conclusion.InspectionWithForm;
import DefectStatus = Conclusion.DefectStatus;

@Component({
    selector: 'app-conclusion-defect-item',
    templateUrl: './conclusion-defect-item.component.html',
    styleUrls: ['./conclusion-defect-item.component.scss']
})
export class ConclusionDefectItemComponent implements OnInit {

    @Input() defect: Conclusion.Defect;

    @Input() inspection: InspectionWithForm;

    public isDefectValid = true;

    constructor() {
    }

    ngOnInit() {
        if (this.defect && this.defect.status === DefectStatus.invalid) {
            this.isDefectValid = false;
        }
    }
}
